<div *ngIf="displayCreditCheckButton" class="credit-check">
  <div>
    <button id="quoteBtn" class="credit-check-button" mat-flat-button color="accent" type="button" (click)="showCreditCheckDiag()" [disabled]="!canPerformCreditCheck">
      <span class="credit-check-icon">
        <img src="/assets/icons/icon-money.svg" class="prefix" alt="money-icon" />
      </span>
      <span>Credit Check</span>
    </button>
    <p *ngIf="statusLabel">
      <img [src]="statusLabel?.icon"
           class="icon-sm"
           aria-hidden="false"
           alt="credit-check-icon" />
      {{statusLabel?.displayStatus}}
    </p>
  </div>
</div>
